import {createApi, createApiClient} from "@3dcalc/3dpClient";

const client = createApiClient({
    apiUrl: process.env.REACT_APP_API_URL || '',
    apiKey: process.env.REACT_APP_API_KEY || '',
    calculatorId: process.env.REACT_APP_CALCULATOR_ID || '',
    onError: (error) => {
        console.error('API Error:', error);
    },
    onUnauthorized: () => {
        console.error('Unauthorized! Check your API key');
    }
});

const { config } = await client.init();

export const apiDemo = createApi(client);

